/**
 * Copyright (c) 2019, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 */

import * as Yup from 'yup';
import React, { useEffect, useState } from 'react';
import { Flex } from 'rebass';
import baseTheme from '../../../themes/baseTheme';
import {
    Grid,
    TextField,
    Container,
    Select,
    MenuItem,
    FormGroup,
    OutlinedInput,
    FormControl,
    InputLabel,
    Typography,
    InputAdornment,
    Radio,
    Checkbox,
    RadioGroup,
    FormControlLabel
} from '@material-ui/core';
import Step from './Step';
import Styled from 'styled-components';
import { Formik, Field } from 'formik';
import { Headline, Body1 } from '../../FontStyles';
import * as _ from '../../../data/constants.js';
var utils = require('../../../Utils.js');

// Page 1 of the form, collects all useful patient information regarding Patient bio and background, if a user already exists most of this information can be set
// pre filled in
const testSchema = Yup.string().min(5, 'Enter more chars');

const FieldContainer = Styled(Flex)`
width: 100%;
margin-bottom: ${props => props.theme.space[3]}px;
border: ${props => (props.border ? props.theme.border : 'none')};
border-radius: ${props => props.theme.radius}px;
.MuiFormControlLabel-root {
    width: 100%;
    padding: ${props => props.theme.space[2]}px};

}

.MuiButtonBase-root {
    margin-left: ${props => props.theme.space[2]}px};
}


`;

class PatientAccountSection extends React.Component {
    state = { errors: [], currentStepNumber: 0 };
    checkStuff = (value, fieldName) => {
        // console.log('check stuff');
        // console.log('value');
        // console.log(value);
        // console.log(_.formSchema.validateSyncAt('firstName', value));
    };

    setCurrentStepNumber = val => {
        console.log('Current Step:' + val);
        this.setState({ currentStepNumber: val });
    };

    // scroll to top on mount

    //Hook for step number, passed down for step to update.

    render() {
        const props = this.props;
        return (
            <div>
                <Step
                    prompt="Who are you creating your account for?"
                    stepNumber={0}
                    currentStepNumber={this.state.currentStepNumber}
                    setCurrentStepNumber={this.setCurrentStepNumber}
                    handleSubmit={this.props.handleSubmit}
                    values={props.values}
                    setFieldValue={props.setFieldValue}
                >
                    <Flex width={1} flexWrap="wrap">
                        <FormControl fullWidth>
                            <RadioGroup
                                name="accountType"
                                value={this.props.values.accountType ? this.props.values.accountType : ''}
                                onChange={this.props.handleChange}
                                row
                            >
                                <FieldContainer border width={1}>
                                    <FormControlLabel
                                        value="patient"
                                        control={<Radio color="default" />}
                                        label={<Typography color="textSecondary">Patient</Typography>}
                                    />
                                </FieldContainer>
                                <FieldContainer border width={1}>
                                    <FormControlLabel
                                        value="caregiver"
                                        control={<Radio color="default" />}
                                        label={<Typography color="textSecondary">Patient and caregiver</Typography>}
                                    />
                                </FieldContainer>
                            </RadioGroup>
                        </FormControl>
                    </Flex>
                </Step>
                <Step
                    prompt="Does the patient have an Apple iPhone or iPod Touch with iOS 13 or above?"
                    stepNumber={1}
                    currentStepNumber={this.state.currentStepNumber}
                    setCurrentStepNumber={this.setCurrentStepNumber}
                    handleSubmit={this.props.handleSubmit}
                    values={props.values}
                    setFieldValue={props.setFieldValue}
                >
                    <FormControl fullWidth>
                        <RadioGroup
                            name="hasIosDevice"
                            value={this.props.values.hasIosDevice ? this.props.values.hasIosDevice : ''}
                            onChange={this.props.handleChange}
                            row
                        >
                            <Flex width={1} flexWrap="wrap">
                                <FieldContainer border width={1}>
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio color="default" />}
                                        label={<Typography color="textSecondary">Yes</Typography>}
                                    />
                                </FieldContainer>
                                <FieldContainer border width={1}>
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio color="default" />}
                                        label={<Typography color="textSecondary">No</Typography>}
                                    />
                                </FieldContainer>
                            </Flex>
                        </RadioGroup>
                    </FormControl>
                </Step>
                <Step
                    prompt="Please enter patient's name and birthdate"
                    stepNumber={2}
                    currentStepNumber={this.state.currentStepNumber}
                    setCurrentStepNumber={this.setCurrentStepNumber}
                    handleSubmit={this.props.handleSubmit}
                    values={props.values}
                    setFieldValue={props.setFieldValue}
                >
                    <Flex width={1} flexWrap="wrap">
                        <FieldContainer width={1}>
                            <TextField
                                name="firstName"
                                variant="outlined"
                                required
                                fullWidth
                                label="First Name"
                                error={this.props.errors.firstName}
                                helperText={this.props.errors.firstName}
                                onChange={this.props.handleChange}
                                onBlur={() => {
                                    this.checkStuff(this.props.values.firstName, 'firstName');
                                }}
                                value={this.props.values.firstName}
                            />
                        </FieldContainer>
                        <FieldContainer width={1}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                label="Last Name"
                                name="lastName"
                                error={Boolean(this.props.errors.lastName)}
                                helperText={this.props.errors.lastName}
                                onChange={this.props.handleChange}
                                value={this.props.values.lastName}
                            />
                        </FieldContainer>
                        <FieldContainer width={1}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                label="Patient's Birthday"
                                name="birthday"
                                type="date"
                                InputLabelProps={{
                                    shrink: true
                                }}
                                inputProps={utils.birthdayRange()}
                                error={this.props.touched.birthday && Boolean(this.props.errors.birthday)}
                                helperText={this.props.touched.birthday ? this.props.errors.birthday : ''}
                                onChange={this.props.handleChange}
                                value={this.props.values.birthday}
                            />
                        </FieldContainer>
                    </Flex>
                </Step>
                <Step
                    prompt={`What is ${
                        this.props.values.firstName ? `${this.props.values.firstName}'s` : "the patient's"
                    } email address?`}
                    stepNumber={3}
                    currentStepNumber={this.state.currentStepNumber}
                    setCurrentStepNumber={this.setCurrentStepNumber}
                    handleSubmit={this.props.handleSubmit}
                    values={props.values}
                    setFieldValue={props.setFieldValue}
                    finalStep
                >
                    <Flex width={1} flexWrap="wrap">
                        <FieldContainer width={1}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                label="Email Address"
                                name="email"
                                type="email"
                                placeholder="Example: jill@jellyfish.com"
                                error={props.touched.email && Boolean(props.errors.email)}
                                helperText={props.touched.email ? props.errors.email : ''}
                                onChange={props.handleChange}
                                value={props.values.email}
                            />
                        </FieldContainer>
                        <FieldContainer width={1}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                label="Confirm Email Address"
                                name="confirmEmail"
                                type="email"
                                placeholder="Example: jill@jellyfish.com"
                                onChange={props.handleChange}
                                value={props.values.confirmEmail}
                            />
                        </FieldContainer>
                        <Flex width={1} textAlign="left">
                            <Body1>
                                This email will be used for an account set up request to the end user and for all
                                Tidepool correspondence.
                            </Body1>
                        </Flex>
                    </Flex>
                </Step>
            </div>
        );
    }
}

export default PatientAccountSection;
